import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { subscriptionManagePath } from '~/constants/community';

import { ActionMenu, type ActionMenuItem } from '../../ui/ActionMenu';
import { Avatar } from '../../ui/Avatar';
import { PillButton } from '../../ui/PillButton';

import { useCommunityMembership } from '../../../_hooks/useCommunityMembership';
import { useMemberMenu } from '../../../_hooks/useMemberMenu';

export const TopBarUser: FC = () => {
  const { t } = useTranslation();
  const { openSignInModal } = useCommunityMembership();
  const { isLoggedIn, displayName, email, subscriberId, avatarUrl, menuItems } = useMemberMenu();

  if (!isLoggedIn) {
    return (
      <PillButton
        variant="primary"
        onClick={() => openSignInModal()}
        className="shrink-0 px-4 transition-opacity hover:opacity-90"
      >
        {t('shared.cta.sign_in')}
      </PillButton>
    );
  }

  const identityItems: ActionMenuItem[] = subscriberId
    ? [
        {
          key: 'subscriber_profile',
          label: displayName,
          description: email ?? undefined,
          to: subscriptionManagePath(subscriberId),
        },
        { type: 'divider', key: 'subscriber_profile_divider' },
      ]
    : [];

  return (
    <ActionMenu
      triggerLabel={t('community.join.member_menu')}
      triggerClassName="flex rounded-full transition-opacity hover:opacity-90"
      trigger={<Avatar src={avatarUrl} alt={displayName} className="size-10" fallbackClassName="bg-gray-300" />}
      placement="bottom-end"
      items={[...identityItems, ...menuItems]}
    />
  );
};
